export const environment = {
	production: false,
	name: 'UAT',
	baseUrl: 'https://uat.api.rapidrent.com/',
	webSocketBaseUrl: 'wss://uat.api.rapidrent.com/cable?token=',
	kioskUrl: 'http://localhost:4567/',
	kiosk: true,
	version: '2.1.4'
}
